import Dropdown from '@deprecated-ui/common/Dropdown';
import styled from 'styled-components';
import { Skeleton } from 'antd';
import color from '@deprecated-ui/_style/color';
import { Text } from '@deprecated-ui/common';
import SelectBase from '@deprecated-ui/widget/Select';
import { InfoTable } from '../DetailModal/InfoTable';

// @ts-expect-error
const { Menu } = Dropdown;

export const SectionWrapper = styled.div``;

export const SectionButton = styled.button.attrs({
  className: 'button-unstyled full-button',
})`
  padding: 0;
`;

export const PortfolioInfoTable = styled(InfoTable)``;

export const PortfolioActionMenu = styled(Menu)`
  & > .ant-dropdown-menu-item-disabled {
    cursor: not-allowed;
    &:hover {
      background-color: #ffffff;
      color: rgba(0, 0, 0, 0.25);
      cursor: not-allowed;
    }
  }

  & > .ant-menu-item-selected {
    background-color: #ffffff !important;
    color: #333333;
  }
`;

export const PortfolioSkeletonBlock = styled(Skeleton.Button).attrs({
  active: true,
})<{ height?: number }>`
  display: block;

  & > .ant-skeleton-button {
    border-radius: 4px;
    height: ${({ height }) => `${height}px`};
    width: 100%;
  }
`;

export const TableWrapper = styled.div`
  width: 100%;
  border-radius: 4px;
  border-bottom-right-radius: none;
  border-bottom-left-radius: none;
`;

export const TableContent = styled.div`
  border: 1px solid ${color.downgray};
  border-radius: 4px;
  padding: 0;
  height: auto;
  margin-bottom: 16px;
`;

export const TableHeader = styled.div`
  border-bottom: 1px solid ${color.downgray};
  border-top: 1px solid ${color.downgray};
  font-size: 12px;

  ${Text} {
    font-weight: 700;
    color: #858585;
  }
`;

export const CustomText = styled.p`
  margin-bottom: 0px;

  &.buy,
  &.open,
  &.active,
  &.ready,
  &.partial,
  &.verified,
  &.submitted,
  &.success,
  &.pending,
  &.request_amend {
    color: ${color.primary};
  }

  &.sell,
  &.rejected {
    color: ${color.sunsetOrange};
  }
`;

export const OrdersTable = styled.div`
  max-height: 160px;
  overflow: auto;

  &.history {
    max-height: 320;
  }
`;

export const OrderRow = styled.button`
  display: flex;
  justify-content: left;
  align-items: center;
  padding: 0 16px;
  margin: 0;
  height: 32px;
  flex-wrap: nowrap;
  gap: 16px;
  color: ${color.highempahis};
  font-size: 12px;
  background: transparent;
  border: none;
  text-align: left;
  width: 100%;

  &:not(:disabled) {
    cursor: pointer;
    &:hover {
      background: ${color.component};
    }
  }
`;

export const Select = styled(SelectBase)`
  .ant-select-selector {
    border-radius: 16px !important;
  }

  .ant-select-selector {
    .ant-select-selection-item {
      .select-label {
        color: ${color.nightRider};
        font-family: var(--font-regular);
        display: inline;
        margin: 0;
        background: transparent;
        padding: 0;
        font-size: 12px;
      }
    }
  }
`;
